import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Paper,
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  Divider,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stack,
  Modal,
  Typography,
  alpha,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CandlestickChartOutlinedIcon from "@mui/icons-material/CandlestickChartOutlined";
import InfoIcon from "@mui/icons-material/Info";
import "./mywallet.css";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import loader from "../../Assets/Images/puff.svg";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import InfoPopUp from "../../Common/InfoPopUp";
import DataTable from "../../Common/DataTable";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const tabStyles = (isSelected) => ({
  color: isSelected ? "#ffffff" : "#666666",
  fontWeight: isSelected ? "bold" : "normal",
  fontSize: "16px",
  textTransform: "uppercase",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  minHeight: 0,
  padding: "6px 12px",
});

const AssetSpotColumn = ["Asset", "Balance", "Action"];

const Infomodal = [
  {
    title: "Cross",
    description:
      "Cross Wallet is a crypto wallet built to hold multiple blockchain cryptocurrencies in one wallet.",
  },
  {
    title: "Crypto Holdings",
    description:
      "You can do margin and funding in your Cryptocurrency from this section.",
  },
  {
    title: "SPOT WALLET",
    description:
      "You can see your Crypto balance, transfer to margins, and fund your Crypto through SPOT WALLET.",
  },
  {
    title: "MARGIN",
    description:
      "You can see your margin wallet balance, used balance, and available margin wallet balance. You can transfer your margin wallet balance to your spot wallet through the transfer to SPOT button.",
  },
  {
    title: "VIEW MY FUNDINGS",
    description:
      "You can see your Fundings here by selecting currency and providing From Date and To Date.",
  },

  {
    title: "Transfer to SPOT",
    description:
      "You can transfer your margin wallet balance to the spot wallet through this SPOT button.",
  },

  {
    title: "Portfolio",
    description:
      "You can see your balances on a contract basis (Perpetual, Quarterly).",
  },
];

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "start",
  borderBottom: "2px solid #616266",
  padding: "16px",
};

const bodyStyle = {
  padding: "16px",
  textAlign: "left",
};

const OPTIONSMARGINURL = WEBSERVICE + "/optionsMargin/";

const MyWalletOption = () => {
  const { btncolor } = useSelector((state) => state);
  const navigate = useNavigate();
  const theme = localStorage.getItem("theme");
  const selectedLeverageType =
    localStorage.getItem("selected_leverage_options")?.slice(0, -1) || 2;
  const [value, setValue] = useState(2);
  const [fiatTab, setFiatTab] = useState("SPOT WALLET");
  const [assetTab, setAssetTab] = useState("SPOT WALLET");
  const [portfolioTab, setPortfolioTab] = useState("PERPETUAL");
  const [fromData, setFromDate] = useState(null);
  const [toData, setToDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [assetFromData, setAssetFromDate] = useState(null);
  const [assetToData, setAssetToDate] = useState(null);
  const [currency, setCurrency] = useState("");
  const [assetCurrency, setAssetCurrency] = useState("");
  const [selected, setSelected] = useState("Cross");
  const [marginModal, setMarginModal] = useState(false);
  const [fundingModal, setFundingModal] = useState(false);

  const [myBalanceListForOption, setMyBalanceListForOption] = useState([]);
  const [myBalanceListForOptionsSpot, setMyBalanceListForOptionsSpot] =
    useState([]);

  const [fiatCurrencyId, setFiatCurrencyId] = useState(null);
  const [amount, setAmount] = useState(0);
  const [cryptoCurrency, setCryptoCurrency] = useState("");
  const [sendAmount, setSendAmount] = useState("");
  const [sendAmountFunding, setSendAmountFunding] = useState("");

  const [marginCurId, setMarginCurId] = useState("");

  const [selectedMarginTypeForOptions, setSelectedMarginTypeForOptions] =
    useState(2);
  const [
    selectedAssetPairForOptionMargin,
    setSelectedAssetPairForOptionMargin,
  ] = useState("");

  const [userBalanceList, setUserBalanceList] = useState([]);
  const [fiatCurrencyList, setFiatCurrencyList] = useState([]);
  const [usdbalance, setUsdbalance] = useState(null);
  const [sgdbalance, setSgdbalance] = useState(null);
  const [eurbalance, setEurbalance] = useState(null);
  const [aedbalance, setAedbalance] = useState(null);
  const [inrbalance, setInrbalance] = useState(null);
  const [gbpbalance, setGbpbalance] = useState(null);
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState(null);

  const [assetPairForFunding, setAssetPairForFunding] = useState("");
  const [assetPairList, setAssetPairList] = useState([]);

  const [fundingHomeViewCrossForOption, setFundingHomeViewCrossForOption] =
    useState([]);
  const [fundingHomeViewFundingForOption, setFundingHomeViewFundingForOption] =
    useState([]);

  const [marginWalletBalanceForOption, setMarginWalletBalanceForOption] =
    useState(0);
  const [usedBalanceForOption, setUsedBalanceForOption] = useState(0);
  const [availableBalanceForOption, setAvailableBalanceForOption] = useState(0);
  const [marginwalletIdForOption, setMarginwalletIdForOption] = useState(null);
  const [currencyIdForOption, setCurrencyIdForOption] = useState(null);
  const [cryptoCurrencyForOption, setCryptoCurrencyForOption] = useState(null);
  const [flag, setFlag] = useState(false);

  const [cryptoCur, setCryptoCur] = useState("");
  const [cryptoid, setCryptoid] = useState("");
  const [cryptomarginwalletId, setCryptomarginwalletId] = useState("");
  const [assetMarginFor, setAssetMarginFor] = useState("");
  const [sendAmountMargin, setSendAmountMargin] = useState("");

  const [marginSpotModal, setMarginSpotModal] = useState(false);

  const [arrayy, setArrayy] = useState(""); // Ensure this is set properly
  const [fundingData, setFundingData] = useState([]);
  const [customerFundingModal, setCustomerFundingModal] = useState(false);

  const [contractListOptions, setContractListOptions] = useState([]);
  const [
    selectedContractTypeIdForOptions,
    setSelectedContractTypeIdForOptions,
  ] = useState(null);

  const [
    portfolioBalanceForOptionPerpetual,
    setPortfolioBalanceForOptionPerpetual,
  ] = useState(null);
  const [
    portfolioBalanceForOptionCurrentQuarter,
    setPortfolioBalanceForOptionCurrentQuarter,
  ] = useState(null);
  const [
    portfolioBalanceForOptionNextQuarter,
    setPortfolioBalanceForOptionNextQuarter,
  ] = useState(null);

  const [portfolioHeadersForOption, setPortfolioHeadersForOption] = useState(
    []
  );
  const [
    portfolioValueForOptionContract1,
    setPortfolioValueForOptionContract1,
  ] = useState([]);
  const [opgn, setOpgn] = useState([]);

  const [curencyName, setCurencyName] = useState("");
  const [baseCurrencyName, setBaseCurrencyName] = useState("");
  const [assetcode, setAssetcode] = useState("");
  const [mpTransactionid, setMpTransactionid] = useState("");
  const [counterAssetPair, setCounterAssetPair] = useState("");
  const [counterLeverage, setCounterLeverage] = useState("");

  const [buyModal, setBuyModal] = useState(false);
  const [sellModal, setSellModal] = useState(false);

  const [infoModal, setInfoModal] = useState(false);
  const [infoIndex, setInfoIndex] = useState(0);

  const handleCloseInfoModal = () => setInfoModal(false);

  const handleInfoModal = (index) => {
    setInfoIndex(index);
    setInfoModal(true);
  };

  const handleBuyClose = () => setBuyModal(false);
  const handleSellClose = () => setSellModal(false);

  const handleCloseMarginSpotModal = () => (
    setMarginSpotModal(false), setSendAmountMargin("")
  );

  const handleCustomerFundingModalClose = () => setCustomerFundingModal(false);

  const eventSourceRef = useRef(null);

  const buttonStyles = (mode) => ({
    backgroundColor: selected === mode ? btncolor : "#111",
    color: selected === mode ? "var(--text-color)" : "#ddd",
    borderRadius: "5px",
    padding: "5px 24px",
    textTransform: "none",
    border: selected === mode ? "none" : "1px solid #333",
    "&:hover": {
      backgroundColor: selected === mode ? btncolor : "#222",
    },
    width: "250px",
  });
  const contentStyle = {
    backgroundColor: theme === "dark" ? "#273338" : "#fff",
    boxShadow: "0 0 60px 30px #fff, 0 0 100px 60px #f0f, 0 0 140px 90px #0ff",
    color: theme === "dark" ? "white" : "black",
    textAlign: "center",
    border: "none",
    width: "400px",
    borderRadius: "8px",
    outline: "none",
  };

  const labels = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];
  const values = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];

  useEffect(() => {
    getUserTransactionBalanceForOptions();
    getUserTransaction();
    getAssetsForOptionsMargin();
    getContractDetailsForOptions();

    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
    };
  }, []);

  useEffect(() => {
    portfolioDeatilsForOption(selectedContractTypeIdForOptions);
  }, [selectedContractTypeIdForOptions]);

  const handleCloseMarginModal = () => (
    setMarginModal(false), setSendAmount("")
  );
  const handleCloseFundingModal = () => (
    setFundingModal(false), setSendAmountFunding(""), setReturnDate(null)
  );
  const handleSelect = (mode) => {
    setSelected(mode);
  };

  const handleChangeCurrency = (event) => {
    setCurrency(event.target.value);
    setFiatCurrencyId(event.target.value?.CURRENCYID);
    somethingChangedForOption(event.target.value?.CURRENCY_NAME);
  };
  const somethingChangedForOption = (event) => {
    const bal = event;
    setFlag(true);

    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    const url = `${OPTIONSMARGINURL}getMarginWalletByCurrency?uuid=${uuid}&currencyName=${bal}&marginType=${selectedMarginTypeForOptions}&leverage=${selectedLeverageType}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + accessToken,
        },
      })
      .then((response) => {
        const responsemargin = response.data;

        if (responsemargin.error !== 1) {
          setMarginWalletBalanceForOption(
            parseFloat(responsemargin.marginWalletBalance).toFixed(
              getSpecificCurrencyPrecision(bal)
            )
          );
          setUsedBalanceForOption(responsemargin.usedBalance);
          setAvailableBalanceForOption(
            parseFloat(responsemargin.availableBalance).toFixed(
              getSpecificCurrencyPrecision(bal)
            )
          );
          setMarginwalletIdForOption(responsemargin.marginWalletId);
          setCurrencyIdForOption(responsemargin.currencyId);
          setCryptoCurrencyForOption(responsemargin.currencyName);
          // alert("Balance is available", 'success'); // Optional
        } else {
          setMarginWalletBalanceForOption(0);
          setUsedBalanceForOption(0);
          setAvailableBalanceForOption(0);
          showToast("error", `No Balance Available for ${bal}`);
        }

        getUserTransaction();
      })
      .catch((error) => {
        console.error("Error fetching margin wallet:", error);
        showToast("error", "Failed to fetch margin wallet information");
      });
  };

  const handleChangeAssetCurrency = (event) => {
    setAssetCurrency(event.target.value);
  };

  const handleChange = (event, newValue) => {
    console.log("newValue", newValue, value);
    setValue(newValue);
  };
  const handleChangeFiatTab = (event, newValue) => {
    setFiatTab(newValue);
  };
  const handleChangeAssetTab = (event, index) => {
    setAssetTab(values[index]);
    setCurrency();
    setMarginWalletBalanceForOption(0);
    setAvailableBalanceForOption(0);
    setAssetCurrency("");
    setAssetFromDate(null);
    setAssetToDate(null);
  };
  const handleChangePortfolioTab = (event, newValue) => {
    setPortfolioTab(newValue);
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const getSpecificCurrencyPrecision = (currency) => {
    // Implement your currency precision logic here
    const precisionMap = {
      USD: 2,
    };
    return precisionMap[currency] || 6;
  };
  const getUserTransaction = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };
    const jsonString = JSON.stringify(userTransObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", "Cannot fetch user balance");
        console.log("Fetching User balance failed");
      } else {
        setUserBalanceList(result.userBalanceList);

        result.userBalanceList.forEach((balance) => {
          if (balance.currencyCode === "USD") {
            setUsdbalance(balance.closingBalance);
            localStorage.setItem("usdbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "SGD") {
            setSgdbalance(balance.closingBalance);
            localStorage.setItem("sgdbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "EUR") {
            setEurbalance(balance.closingBalance);
            localStorage.setItem("eurbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "AED") {
            setAedbalance(balance.closingBalance);
            localStorage.setItem("aedbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "INR") {
            setInrbalance(balance.closingBalance);
            localStorage.setItem("inrbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "GBP") {
            setGbpbalance(balance.closingBalance);
            localStorage.setItem("gbpbalance", balance.closingBalance);
          }
        });

        setSelectedCryptoCurrency(localStorage.getItem("selected_currency"));

        const fiatCurrencies = result.userBalanceList.filter(
          (balance) => balance.currencyType === "1"
        );
        const basecur = result.userBalanceList.filter(
          (x) => x.currencyCode == "USD"
        );

        setFiatCurrencyList(fiatCurrencies);
        setFiatCurrencyId(basecur[0]?.currencyId);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
      } else {
        // showToast("error", error?.response?.data?.error?.error_msg);
      }
    }
  };

  const checkUserBlockStatus = async () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/userAccountStatus`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error?.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        return false;
      }

      if (response.data.status !== 1) {
        //logout
        showToast("error", "Your user has been blocked by Admin");
        return false;
      }

      return true;
    } catch (error) {
      console.log("Error in checkUserBlockStatus:", error);
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === "401")
      ) {
        //logout
      }
      return false;
    }
  };

  const getUserTransactionBalanceForOptions = () => {
    const uuid = localStorage.getItem("uuid");
    const url = `${OPTIONSMARGINURL}getMainWalletBalanceStream?uuid=${uuid}`;

    if (eventSourceRef.current) {
      eventSourceRef.current.close();
    }

    eventSourceRef.current = new EventSource(url);

    eventSourceRef.current.onmessage = (event) => {
      let result = JSON.parse(event.data);
      const balanceList = result.userBalance || [];

      setMyBalanceListForOption(balanceList);

      const filteredSpotList = balanceList.filter(
        (item) => item.currencyType === 1
      );
      setMyBalanceListForOptionsSpot(filteredSpotList);
    };
  };

  const handleCrossAssetSpotClick = (
    modalType,
    currentBalance,
    currency,
    currencyId = ""
  ) => {
    setFiatCurrencyId(currencyId);
    setAmount(currentBalance);
    setCryptoCurrency(currency);
    // setMarginCurId(curId);
    if (modalType === "margin") {
      setMarginModal(true);
    } else {
      setFundingModal(true);
    }
    checkUserBlockStatus();
  };

  const lendingPriceForOptions = () => {
    if (sendAmount == 0 || sendAmount === "") {
      showToast("error", "Please enter a valid amount");
      return;
    }
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const objdata = {
      uuid: uuid,
      amount: sendAmount,
      currencyId: fiatCurrencyId,
      baseCurrencyId: fiatCurrencyId,
      unitPrice: "0",
      marginType: selectedMarginTypeForOptions,
      assetPair:
        selectedAssetPairForOptionMargin !== undefined &&
        selectedAssetPairForOptionMargin !== ""
          ? selectedAssetPairForOptionMargin
          : cryptoCurrency.toUpperCase(),
    };

    axios
      .post(
        `${OPTIONSMARGINURL}transferBalanceToMWB`,
        JSON.stringify(objdata),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + accessToken,
          },
        }
      )
      .then((response) => {
        const res = response.data;
        if (res.error === 1) {
          showToast("error", "Margin not successful");
        } else {
          showToast("success", "Margin successful");
        }
        getUserTransaction();
        getUserTransactionBalanceForOptions();
        handleCloseMarginModal();
      })
      .catch((error) => {
        console.error("Error while processing margin transfer:", error);
        showToast("error", "An error occurred");
      });
  };
  const formatDate = (value) => dayjs(value).format("DD-MM-YYYY");

  const fundBuyForOptions = async () => {
    if (sendAmountFunding == 0 || sendAmountFunding === "") {
      showToast("error", "Please enter a valid amount");
      return;
    }
    let objdata = {
      uuid: localStorage.getItem("uuid"),
      amount: sendAmountFunding,
      currencyId: fiatCurrencyId,
      unitPrice: 50,
      returnDate: formatDate(returnDate),
      assetPair: cryptoCurrency.toUpperCase(),
    };

    if (assetPairForFunding === "") {
      objdata.baseCurrencyId = fiatCurrencyId;
    } else {
      for (let i = 0; i < assetPairList.length; i++) {
        if (assetPairForFunding.toUpperCase() === assetPairList[i].assetPair) {
          objdata.baseCurrencyId = assetPairList[i].baseCurrencyId;
          break;
        }
      }
    }

    try {
      const response = await axios.post(
        `${OPTIONSMARGINURL}transferFund`,
        JSON.stringify(objdata),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.returnId !== 1) {
        showToast("error", response.data.message);
      } else {
        showToast("success", "Funding successful");
      }

      getUserTransactionBalanceForOptions();
      handleCloseFundingModal();
    } catch (error) {
      console.error("Funding failed:", error);
      showToast("error", "An error occurred while funding");
    }
  };

  const getAssetsForOptionsMargin = () => {
    axios
      .get(`${OPTIONSMARGINURL}fundingHomeView`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const data = response.data;
        const currenciesCross = data.P_OPTIONS_MARGIN_CURRENCY || [];
        const currenciesFunding = data.P_FUNDING_CURRENCY || [];

        const arrCross = currenciesCross.filter(
          (item) => item.CURRENCY_TYPE !== 1
        );
        const arrFunding = currenciesFunding.filter(
          (item) => item.CURRENCY_TYPE !== 1
        );

        setFundingHomeViewCrossForOption(arrCross);
        setFundingHomeViewFundingForOption(arrFunding);
      })
      .catch((error) => {
        console.error("Error fetching options margin assets:", error);
      });
  };

  const cryptoholdingmarginForOption = (
    cur1,
    bal,
    curId,
    cryptomarginwltid,
    operation
  ) => {
    setCryptoCur(cur1);
    setAmount(bal);
    setCryptoid(curId ?? "");
    setCryptomarginwalletId(cryptomarginwltid);
    setAssetMarginFor(operation);
    setMarginSpotModal(true);
  };

  const fiatholdingPrice = () => {
    if (sendAmountMargin == 0 || sendAmountMargin === "") {
      showToast("error", "Please enter a valid amount");
      return;
    }
    const cryptomargintowalletObj = {
      uuid: localStorage.getItem("uuid"),
      marginWalletId: cryptomarginwalletId,
      amount: Number(sendAmountMargin),
      currencyId: cryptoid,
      marginType: 2,
    };

    const jsonString = JSON.stringify(cryptomargintowalletObj);

    let url = `${OPTIONSMARGINURL}transferBalanceMarginToMainWallet`;

    axios
      .post(url, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.error !== 0) {
          showToast("error", result.message);
        } else {
          showToast("success", result.message);
          getUserTransaction();
          getUserTransactionBalanceForOptions();
          somethingChangedForOption(currency?.CURRENCY_NAME);
          handleCloseMarginSpotModal();
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        showToast("error", "An error occurred. Please try again.");
      });
  };

  const findingViewForInputServiseForOptions = async () => {
    if (assetCurrency === "") {
      showToast("error", "Please Fill-up all field");
      return;
    }
    if (assetFromData === null && assetToData === null) {
      showToast("error", "Please Fill-up from date and to date both");
      return;
    }
    if (assetFromData > assetToData) {
      showToast("error", "To Date Must be greater than from date!!");
      return;
    }

    const objdatafund = {
      uuid: localStorage.getItem("uuid"),
      currencyId: assetCurrency,
      fromDate: formatDate(assetFromData),
      toDate: formatDate(assetToData),
    };

    try {
      const response = await axios.post(
        `${OPTIONSMARGINURL}fundingViewByInputValue`,
        JSON.stringify(objdatafund),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const list = response.data.fundingHomeResponseDtoList;
      const arr = list.map((item) => {
        const currencyName = item.currencyName;
        const amountPrecision =
          currencyName === "US Dollar"
            ? getSpecificCurrencyPrecision("USD")
            : currencyName === "BCC"
            ? getSpecificCurrencyPrecision("BCH")
            : getSpecificCurrencyPrecision(currencyName);

        return {
          currencyName: currencyName,
          lendingDate: item.lendingDate,
          returnDate: item.returnDate,
          amount: parseFloat(item.amount).toFixed(amountPrecision),
        };
      });

      setFundingData(arr);
      setAssetToDate(null);
      setAssetFromDate(null);
      setAssetCurrency("");
      setCustomerFundingModal(true);
    } catch (error) {
      console.error("Error fetching funding data:", error);
    }
  };

  const getContractDetailsForOptions = () => {
    axios
      .get(`${WEBSERVICE}optionsTrade/getContractsName`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.statusCode === 0) {
          setContractListOptions(result.contractList);
          console.log(result.contractList);

          if (result.contractList.length !== 0) {
            console.log(result.contractList[0]["contractTypeId"]);
            setSelectedContractTypeIdForOptions(
              result.contractList[0]["contractTypeId"]
            );
            userPortfolioBalanceForOption(
              result.contractList[0]["contractTypeId"]
            );
          }
        } else {
          showToast("error", result.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching contract details:", error);
        showToast(
          "error",
          "An error occurred while fetching contract details."
        );
      });
  };

  const userPortfolioBalanceForOption = (contractId) => {
    const uuid = localStorage.getItem("uuid");
    const contractTypeId = contractId;
    const marginType = selectedMarginTypeForOptions;

    const url = `${OPTIONSMARGINURL}userPortfolioBalance?uuid=${uuid}&marginType=${marginType}&contractTypeId=${contractTypeId}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const userBalance = response.data.userBalance;
        setPortfolioBalanceForOptionPerpetual(userBalance);
        setPortfolioBalanceForOptionCurrentQuarter(userBalance);
        setPortfolioBalanceForOptionNextQuarter(userBalance);
      })
      .catch((error) => {
        console.error("Error fetching portfolio balance:", error);
      });
  };

  const portfolioDeatilsForOption = (id) => {
    const url = `${OPTIONSMARGINURL}portfolioDetails?uuid=${localStorage.getItem(
      "uuid"
    )}&marginType=${selectedMarginTypeForOptions}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        setPortfolioHeadersForOption(response.data.header);
        const values = response.data.values || [];
        let arrOpt = [];

        if (values.length !== 0) {
          for (let i = 0; i < values.length; i++) {
            if (values[i].contractTypeId === id) {
              arrOpt.push(values[i]);
            }
          }

          // const pagination = [];
          // for (let i = 1; i <= Math.ceil(ototalCount / 20); i++) {
          //   pagination.push(i);
          // }
          // setOpgn(pagination);
        } else {
          arrOpt = [];
        }

        setPortfolioValueForOptionContract1(arrOpt);
      })
      .catch((error) => {
        console.error("Error fetching portfolio details:", error);
      });
  };

  const handleContractClick = (contractId) => {
    setSelectedContractTypeIdForOptions(contractId);
    checkUserBlockStatus();
    userPortfolioBalanceForOption(contractId);
    portfolioDeatilsForOption(contractId);
  };

  const handleBuySellClick = (
    amount,
    curName,
    base_currency,
    assetCode,
    mpportfolioid,
    assetpair,
    leverage,
    type
  ) => {
    setAmount(amount);
    setCurencyName(curName);
    setBaseCurrencyName(base_currency);
    setAssetcode(assetCode);
    setMpTransactionid(mpportfolioid);
    setCounterAssetPair(assetpair);
    setCounterLeverage(leverage);
    if (type === "buy") {
      setBuyModal(true);
    } else {
      setSellModal(true);
    }
  };

  const handleBuy = async () => {
    const buyingCrypto = localStorage.getItem("buying_crypto_asset");
    const sellingCrypto = localStorage.getItem("selling_crypto_asset");

    try {
      const response = await axios.get(
        `https://options-socket.paybito.com/oSocketStream/api/marketPrice`,
        {
          params: {
            symbol: counterAssetPair,
            side: "BID",
            amount: amount,
            marginType: selectedMarginTypeForOptions,
          },
          headers: { "Content-Type": "application/json" },
        }
      );

      const result = response.data;
      if (result.statuscode !== 0) {
        const inputObj = {
          userId: localStorage.getItem("user_id"),
          selling_asset_code: baseCurrencyName.toUpperCase(),
          buying_asset_code: curencyName.toUpperCase(),
          amount: parseFloat(amount),
          price: parseFloat(result.price1),
          offerType: "P",
          txn_type: "1",
          assetCode: assetcode,
          portfolioId: mpTransactionid,
          assetPair: counterAssetPair,
          leverage: counterLeverage,
          uuid: localStorage.getItem("uuid"),
        };

        if (result.price1 * amount >= 0.001) {
          const offerResponse = await axios.post(
            `${WEBSERVICE}optionsTrade/TradeCreateOffer`,
            JSON.stringify(inputObj),
            {
              headers: {
                "Content-Type": "application/json",
                authorization: "BEARER " + localStorage.getItem("access_token"),
              },
            }
          );
          const offerResult = offerResponse.data;
          if (offerResult.error.error_data !== 0) {
            showToast("error", offerResult.error.error_msg);
          } else {
            showToast("success", offerResult.error.error_msg);
            localStorage.setItem("last_selected_tab_of_wallet", "margin");
            handleBuyClose();
            setAssetTab("SPOT WALLET");
            portfolioDeatilsForOption(selectedContractTypeIdForOptions);
            userPortfolioBalanceForOption(selectedContractTypeIdForOptions);
          }
        } else {
          showToast("error", "Offer Value is lesser than permissible value");
        }
      } else {
        showToast("error", result.message);
      }
    } catch (error) {
      console.error(error);
      showToast("error", "Something went wrong");
    }
  };

  const validateNumber = (e) => {
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "Escape" ||
      e.key === "Enter" ||
      e.key.startsWith("Arrow")
    ) {
      return;
    }
    if (e.key === "." && !e.currentTarget.value.includes(".")) {
      return;
    }
    // Block anything that's not a digit
    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  // Extra validation on blur/change
  const handleBlur = (e) => {
    const value = e.target.value.trim();

    // Disallow empty, "0", "0.0", "0.00", "0.000", etc.
    if (value === "" || Number(value) === 0) {
      e.target.value = ""; // clear it or show error
      showToast("error", "Value cannot be 0 or 0.00 etc.");
    }
  };

  const handleSell = async () => {
    try {
      const response = await axios.get(
        `https://options-socket.paybito.com/oSocketStream/api/marketPrice`,
        {
          params: {
            symbol: counterAssetPair,
            side: "ASK",
            amount: amount,
            marginType: selectedMarginTypeForOptions,
          },
          headers: { "Content-Type": "application/json" },
        }
      );

      const result = response.data;
      if (result.statuscode !== 0) {
        const inputObj = {
          userId: localStorage.getItem("user_id"),
          selling_asset_code: curencyName.toUpperCase(),
          buying_asset_code: baseCurrencyName.toUpperCase(),
          amount: parseFloat(amount),
          price: parseFloat(result.price1),
          offerType: "P",
          txn_type: "2",
          assetCode: assetcode,
          portfolioId: mpTransactionid,
          assetPair: counterAssetPair,
          leverage: counterLeverage,
          uuid: localStorage.getItem("uuid"),
        };

        if (result.price1 * amount >= 0.001) {
          const offerResponse = await axios.post(
            `${WEBSERVICE}optionsTrade/TradeCreateOffer`,
            JSON.stringify(inputObj),
            {
              headers: {
                "Content-Type": "application/json",
                authorization: "BEARER " + localStorage.getItem("access_token"),
              },
            }
          );
          const offerResult = offerResponse.data;
          if (offerResult.error.error_data !== 0) {
            showToast("error", offerResult.error.error_msg);
          } else {
            showToast("success", offerResult.error.error_msg);
            localStorage.setItem("last_selected_tab_of_wallet", "margin");
            handleSellClose();
            setAssetTab("SPOT WALLET");
            portfolioDeatilsForOption(selectedContractTypeIdForOptions);
            userPortfolioBalanceForOption(selectedContractTypeIdForOptions);
          }
        } else {
          showToast("error", "Offer Value is lesser than permissible value");
        }
      } else {
        showToast("error", result.message);
      }
    } catch (error) {
      console.error(error);
      showToast("error", "Something went wrong");
    }
  };

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <CandlestickChartOutlinedIcon
              sx={{ color: "#fff", fontSize: 30 }}
            />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Options Wallet</Typography>
            <Typography sx={heroSubtitle}>
              Manage your options margin, funding and portfolio positions
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Margin Mode ── */}
      <Box sx={{ ...mainCard, mb: 3 }}>
        <Box
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: "1px solid rgba(125,125,125,0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.9rem",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              color: "var(--text-color)",
            }}
          >
            CROSS
          </Typography>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => handleInfoModal(0)}
          >
            <InfoIcon
              style={{
                fontSize: "15px",
                color: "var(--text-color)",
                opacity: 0.5,
              }}
            />
          </span>
        </Box>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Box sx={sectionCard}>
              <Box sx={sectionHeader}>
                <Typography sx={cardSectionTitle}>
                  Crypto Holdings{" "}
                  <span
                    style={{ cursor: "pointer", marginLeft: "6px" }}
                    onClick={() => handleInfoModal(1)}
                  >
                    <InfoIcon
                      style={{
                        fontSize: "15px",
                        verticalAlign: "middle",
                        opacity: 0.5,
                      }}
                    />
                  </span>
                </Typography>
              </Box>
              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {labels.map((label, index) => (
                    <Button
                      key={label}
                      onClick={() => handleChangeAssetTab(null, index)}
                      sx={{
                        flex: 1,
                        mx: 1,
                        color:
                          assetTab === values[index]
                            ? "var(--btn-color)"
                            : "var(--text-color)",
                        fontSize: "14px",
                        fontWeight: "bold",
                        textTransform: "none",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                      }}
                    >
                      {label}
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleInfoModal(2 + index);
                        }}
                      >
                        {/* <i className="fa fa-info-circle" aria-hidden="true"></i> */}
                        <InfoIcon style={{ fontSize: "15px" }} />
                      </span>
                    </Button>
                  ))}
                </Box>
              </Box>

              <TableContainer
                className="wallet_table future_wallet"
                sx={{ px: 2 }}
              >
                {assetTab === "SPOT WALLET" && (
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {AssetSpotColumn.map((column, i) => (
                          <TableCell key={i} sx={modernTableHeadCell}>
                            {column}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {myBalanceListForOption?.length !== 0 ? (
                        myBalanceListForOption?.map(
                          (b, i) =>
                            b.currencyType === 2 && (
                              <TableRow key={i} sx={modernTableBodyRow}>
                                <TableCell sx={modernTableBodyCell}>
                                  {b?.currency}
                                </TableCell>
                                <TableCell sx={modernTableBodyCell}>
                                  {b?.currentBalance}
                                </TableCell>
                                <TableCell
                                  className="d-flex justify-content-end align-items-center"
                                  sx={modernTableBodyCell}
                                >
                                  {b?.isOptionsMargin === 1 && (
                                    <>
                                      <a
                                        href="#"
                                        style={{
                                          marginRight: "5px",
                                          // color:
                                          //   theme === "dark" ? "#fff" : "#000",
                                        }}
                                        onClick={() =>
                                          handleCrossAssetSpotClick(
                                            "margin",
                                            b.currentBalance,
                                            b.currency,
                                            b.currencyId
                                          )
                                        }
                                      >
                                        MARGIN
                                      </a>
                                    </>
                                  )}
                                  {b?.isOptionsFunding === 1 && (
                                    <>
                                      <a
                                        href="#"
                                        style={
                                          {
                                            // color:
                                            //   theme === "dark" ? "#fff" : "#000",
                                          }
                                        }
                                        onClick={() =>
                                          handleCrossAssetSpotClick(
                                            "funding",
                                            b.currentBalance,
                                            b.currency,
                                            b.currencyId
                                          )
                                        }
                                      >
                                        FUNDING
                                      </a>
                                    </>
                                  )}
                                </TableCell>
                              </TableRow>
                            )
                        )
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} className="text-center">
                            <img src={loader} width="50" alt="" />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                )}
                {assetTab === "MARGIN" && (
                  <Box sx={{ px: 2 }}>
                    <Grid
                      container
                      spacing={2}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Grid size={3} sx={{ textAlign: "start", color: "gray" }}>
                        Asset :
                      </Grid>
                      <Grid size={6}>
                        <FormControl
                          fullWidth
                          sx={{
                            backgroundColor: "var(--body-color-less)",
                            mt: 2,
                          }}
                        >
                          <InputLabel
                            id="currency-select-label"
                            // sx={{
                            //   color: theme === "dark" ? "#fff" : "#000",
                            //   "&.Mui-focused": {
                            //     color: theme === "dark" ? "#fff" : "#000",
                            //   },
                            // }}
                          >
                            Select Currency
                          </InputLabel>
                          <Select
                            labelId="currency-select-label"
                            id="currency-select"
                            value={currency}
                            label="Select Currency"
                            onChange={handleChangeCurrency}
                            sx={{
                              color: "var(--text-color)",
                              textAlign: "start",
                              backgroundColor: "var(--body-color-less)",
                              borderRadius: 1,
                              // ".MuiOutlinedInput-notchedOutline": {
                              //   borderColor: "#2c2d33",
                              // },
                              // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              //   borderColor: "#555",
                              // },
                              // "&:hover .MuiOutlinedInput-notchedOutline": {
                              //   borderColor: "#555",
                              // },
                              // ".MuiSvgIcon-root ": {
                              //   fill: "#fff !important",
                              // },
                            }}
                          >
                            {fundingHomeViewCrossForOption?.map((d, i) =>
                              d?.CURRENCY_NAME !== "BCC" ? (
                                <MenuItem value={d}>
                                  {d?.CURRENCY_NAME}
                                </MenuItem>
                              ) : (
                                <MenuItem value={"BCH"}>BCH</MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid size={3} />
                      <Grid size={12} sx={{ textAlign: "start" }}>
                        <p className="pb-2 text-secondary">
                          Margin Wallet Balance:{" "}
                          <span className="text-success">
                            {marginWalletBalanceForOption}
                          </span>
                        </p>
                        {/* <p className="pb-2 text-secondary">Used Balance: <span className="text-success"></span></p> */}
                        <p className="pb-2 text-secondary">
                          Available Balance:{" "}
                          <span className="text-success">
                            {availableBalanceForOption}
                          </span>
                        </p>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <p className=" text-secondary">Transfer To :</p>
                          <ContainedButton
                            variant="contained"
                            sx={{ mx: 1 }}
                            size="small"
                            onClick={() =>
                              cryptoholdingmarginForOption(
                                cryptoCurrencyForOption,
                                marginWalletBalanceForOption,
                                currencyIdForOption,
                                marginwalletIdForOption,
                                "options"
                              )
                            }
                          >
                            Spot
                          </ContainedButton>
                          <span
                            style={{
                              cursor: "pointer",
                              margin: "5px",
                              color: "gray",
                            }}
                            onClick={() => handleInfoModal(5)}
                          >
                            <InfoIcon style={{ fontSize: "15px" }} />
                          </span>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}
                {assetTab === "VIEW MY FUNDINGS" && (
                  <Box sx={{ px: 2 }}>
                    <Grid
                      container
                      spacing={2}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Grid
                        size={{ xs: 4, sm: 12, md: 3 }}
                        sx={{ textAlign: "start" }}
                      >
                        Asset Provided:{""}
                      </Grid>
                      <Grid size={{ xs: 8, sm: 12, md: 6 }}>
                        <FormControl
                          fullWidth
                          sx={{
                            backgroundColor: "var(--body-color-less)",
                            mt: 2,
                          }}
                        >
                          <InputLabel
                            id="currency-select-label"
                            sx={{
                              color: "var(--text-color)",
                            }}
                          >
                            Select Currency
                          </InputLabel>
                          <Select
                            labelId="currency-select-label"
                            id="currency-select"
                            value={assetCurrency}
                            label="Select Currency"
                            onChange={handleChangeAssetCurrency}
                            sx={{
                              color: "var(--text-color)",
                              textAlign: "start",
                              // backgroundColor: "#1e1f24",
                              borderRadius: 1,
                              // ".MuiOutlinedInput-notchedOutline": {
                              //   borderColor: "#2c2d33",
                              // },
                              // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              //   borderColor: "#555",
                              // },
                              // "&:hover .MuiOutlinedInput-notchedOutline": {
                              //   borderColor: "#555",
                              // },
                              // ".MuiSvgIcon-root ": {
                              //   fill: "#fff !important",
                              // },
                            }}
                          >
                            {fundingHomeViewFundingForOption?.map((d, i) =>
                              d?.CURRENCY_NAME !== "BCC" ? (
                                <MenuItem value={d?.CURRENCYID}>
                                  {d?.CURRENCY_NAME}
                                </MenuItem>
                              ) : (
                                <MenuItem value={"BCH"}>BCH</MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 3 }} />
                      <Grid size={{ xs: 4, sm: 12, md: 3 }}>
                        <p className=" text-start">From Date</p>
                      </Grid>
                      <Grid size={{ xs: 8, sm: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format="DD-MM-YYYY"
                            value={assetFromData}
                            onChange={(newValue) => setAssetFromDate(newValue)}
                            slots={{
                              openPickerIcon: CalendarMonthIcon,
                            }}
                            sx={{
                              backgroundColor: "var(--body-color-less)",
                            }}
                            slotProps={{
                              textField: {
                                placeholder: "dd-mm-yyyy",
                                fullWidth: true,
                                // sx: {
                                //   backgroundColor: "#0F111A",
                                //   input: { color: "#B0B3B8" }, // text color
                                //   svg: { color: "#B0B3B8" }, // icon color
                                //   borderRadius: 1,
                                // },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 3 }} />
                      <Grid size={{ xs: 4, sm: 12, md: 3 }}>
                        <p className=" text-start">To Date &nbsp; &nbsp;</p>
                      </Grid>
                      <Grid size={{ xs: 8, sm: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format="DD-MM-YYYY"
                            value={assetToData}
                            onChange={(newValue) => setAssetToDate(newValue)}
                            slots={{
                              openPickerIcon: CalendarMonthIcon,
                            }}
                            sx={{
                              backgroundColor: "var(--body-color-less)",
                            }}
                            slotProps={{
                              textField: {
                                placeholder: "dd-mm-yyyy",
                                fullWidth: true,
                                // sx: {
                                //   backgroundColor: "#0F111A",
                                //   input: { color: "#B0B3B8" }, // text color
                                //   svg: { color: "#B0B3B8" }, // icon color
                                //   borderRadius: 1,
                                // },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 3 }} />
                      <Grid
                        size={{ xs: 12, sm: 12, md: 3 }}
                        sx={{ display: "flex", justifyContent: "start" }}
                      >
                        <ContainedButton
                          variant="contained"
                          sx={{ mx: 1 }}
                          onClick={findingViewForInputServiseForOptions}
                        >
                          Submit
                        </ContainedButton>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ ...mainCard, mt: 3 }}>
        <Box sx={sectionHeader}>
          <Typography
            sx={{
              fontSize: "1.1rem",
              fontWeight: 700,
              color: "var(--text-color)",
            }}
          >
            Portfolio{" "}
            <span
              style={{ cursor: "pointer", marginLeft: "6px" }}
              onClick={() => handleInfoModal(6)}
            >
              <InfoIcon
                style={{
                  fontSize: "15px",
                  verticalAlign: "middle",
                  opacity: 0.5,
                }}
              />
            </span>
          </Typography>
        </Box>
        <Box sx={{ p: { xs: 1.5, md: 2 } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 2,
                width: "100%",
              }}
            >
              {contractListOptions?.map((contract, i) => (
                <Grid size={{ xs: 4, sm: 3, md: 2 }}>
                  <Typography
                    key={i}
                    onClick={() => handleContractClick(contract.contractTypeId)}
                    sx={{
                      cursor: "pointer",
                      fontWeight: 700,
                      fontSize: "0.95rem",
                      color:
                        selectedContractTypeIdForOptions ===
                        contract.contractTypeId
                          ? "var(--text-color)"
                          : "var(--text-color)",
                      opacity:
                        selectedContractTypeIdForOptions ===
                        contract.contractTypeId
                          ? 1
                          : 0.45,
                      transition: "opacity 0.15s",
                    }}
                  >
                    {contract.contractName}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Stack direction="row" spacing={1} sx={{ mt: 4 }}>
            {["Cross"].map((mode) => (
              <Button
                key={mode}
                onClick={() => handleSelect(mode)}
                sx={buttonStyles(mode)}
                startIcon={
                  selected === mode ? (
                    <CheckCircleIcon fontSize="small" />
                  ) : null
                }
              >
                {mode}
              </Button>
            ))}
          </Stack>

          <Box sx={{ ...mainCard, mt: 2 }}>
            <TableContainer className="wallet_table" sx={{ p: 2, my: 2 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow sx={modernTableHeadRow}>
                    <TableCell sx={modernTableHeadCell}>
                      Contract Name
                    </TableCell>
                    <TableCell sx={modernTableHeadCell}>Balance</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {portfolioBalanceForOptionPerpetual?.length !== 0 ? (
                    portfolioBalanceForOptionPerpetual?.map((p, i) => (
                      <TableRow sx={modernTableBodyRow}>
                        <TableCell sx={modernTableBodyCell}>
                          {p.assetPair}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {p.amount}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2} className="text-start">
                        No Data
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{ ...mainCard, mt: 2 }}>
            <TableContainer
              className="wallet_table bottom_t"
              sx={{ p: 2, my: 2 }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow sx={modernTableHeadRow}>
                    {portfolioHeadersForOption?.map(
                      (label, i) =>
                        label !== "FULL NAME" && (
                          <TableCell sx={modernTableHeadCell} key={i}>
                            {label}
                          </TableCell>
                        )
                    )}
                    <TableCell sx={modernTableHeadCell}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {portfolioValueForOptionContract1?.map((p, i) => (
                    <TableRow key={i} sx={modernTableBodyRow}>
                      <TableCell sx={modernTableBodyCell}>
                        {p.mpTransactionId}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {p.transactionDate}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {p.currencyName}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {p.baseCurrency}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>{p.amount}</TableCell>
                      <TableCell sx={modernTableBodyCell}>{p.price}</TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {p.portfolioType}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {p.assetPair}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {p.leverage}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.transactionType === 2 && (
                          <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() =>
                              handleBuySellClick(
                                p.amount,
                                p.currencyName,
                                p.baseCurrency,
                                p.assetCode,
                                p.mpTransactionId,
                                p.assetPair,
                                p.leverage,
                                "buy"
                              )
                            }
                          >
                            Buy
                          </Button>
                        )}
                        {p.transactionType === 1 && (
                          <Button
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={() =>
                              handleBuySellClick(
                                p.amount,
                                p.currencyName,
                                p.baseCurrency,
                                p.assetCode,
                                p.mpTransactionId,
                                p.assetPair,
                                p.leverage,
                                "sell"
                              )
                            }
                          >
                            Sell
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>

      <ModalContent
        open={marginModal}
        onClose={handleCloseMarginModal}
        title={`Margin`}
      >
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "center", mt: 2 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Amount available:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={amount}
              readOnly
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Send amount:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={sendAmount}
              onChange={(e) => setSendAmount(e.target.value)}
              onKeyDown={(e) => validateNumber(e)}
              onBlur={handleBlur}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleCloseMarginModal}>
            Close
          </OutlinedButton>
          {sendAmount &&
            0 < Number(sendAmount) &&
            Number(sendAmount) <= amount && (
              <ContainedButton
                variant="contained"
                sx={{ mx: 2 }}
                onClick={lendingPriceForOptions}
              >
                Send
              </ContainedButton>
            )}
        </Box>
      </ModalContent>

      <ModalContent
        open={fundingModal}
        onClose={handleCloseFundingModal}
        title={`Funding`}
      >
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "center", mt: 2 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Amount available:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={amount}
              readOnly
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Send amount:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={sendAmountFunding}
              onChange={(e) => setSendAmountFunding(e.target.value)}
              onKeyDown={(e) => validateNumber(e)}
              onBlur={handleBlur}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Return Date:</Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD-MM-YYYY"
                value={returnDate}
                minDate={dayjs()}
                onChange={(newValue) => setReturnDate(newValue)}
                slots={{
                  openPickerIcon: CalendarMonthIcon,
                }}
                sx={
                  {
                    // backgroundColor: theme === "dark" ? "#0F111A" : "#a89f9f",
                  }
                }
                slotProps={{
                  textField: {
                    placeholder: "dd-mm-yyyy",
                    fullWidth: true,
                    // sx: {
                    //   backgroundColor: "#0F111A",
                    //   input: { color: "#B0B3B8" }, // text color
                    //   svg: { color: "#B0B3B8" }, // icon color
                    //   borderRadius: 1,
                    // },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 2 }} />
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleCloseFundingModal}>
            Close
          </OutlinedButton>
          {sendAmountFunding &&
            0 < Number(sendAmountFunding) &&
            Number(sendAmountFunding) <= amount &&
            returnDate && (
              <ContainedButton
                variant="contained"
                sx={{ mx: 2 }}
                onClick={fundBuyForOptions}
              >
                Send
              </ContainedButton>
            )}
        </Box>
      </ModalContent>

      <ModalContent
        open={marginSpotModal}
        onClose={handleCloseMarginSpotModal}
        title={`Transfer To Spot`}
      >
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "center", mt: 2 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Amount available:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={amount}
              readOnly
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Send amount:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={sendAmountMargin}
              onChange={(e) => setSendAmountMargin(e.target.value)}
              onKeyDown={(e) => validateNumber(e)}
              onBlur={handleBlur}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton
            variant="outlined"
            onClick={handleCloseMarginSpotModal}
          >
            Close
          </OutlinedButton>
          {sendAmountMargin &&
            0 < Number(sendAmountMargin) &&
            Number(sendAmountMargin) <= amount && (
              <ContainedButton
                variant="contained"
                sx={{ mx: 2 }}
                onClick={fiatholdingPrice}
              >
                Send
              </ContainedButton>
            )}
        </Box>
      </ModalContent>

      <ModalContent
        open={customerFundingModal}
        onClose={handleCustomerFundingModalClose}
        title={`Customer Funding Details View`}
      >
        <Paper sx={{ mt: 2 }}>
          <DataTable
            colums={["Currency Name", "Lending Date", "Return Date", "Amount"]}
          >
            {fundingData?.length != 0 ? (
              fundingData?.map((d, i) => (
                <TableRow key={i}>
                  <TableCell>{d?.currencyName}</TableCell>
                  <TableCell> {d?.lendingDate}</TableCell>
                  <TableCell> {d?.returnDate}</TableCell>
                  <TableCell> {d?.amount}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4}>No Data Found</TableCell>
              </TableRow>
            )}
          </DataTable>
        </Paper>

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton
            variant="outlined"
            onClick={handleCustomerFundingModalClose}
          >
            Close
          </OutlinedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={buyModal}
        onClose={handleBuyClose}
        title={`Buy Offer`}
      >
        <p className="text-center text-secondary mt-3">
          Are you sure you want to place this Buy offer?
        </p>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleBuyClose}>
            No
          </OutlinedButton>

          <ContainedButton
            variant="contained"
            sx={{ mx: 2 }}
            onClick={handleBuy}
          >
            Yes
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={sellModal}
        onClose={handleSellClose}
        title={`Sell Offer`}
      >
        <p className="text-center text-secondary mt-3">
          Are you sure you want to place this sell offer?
        </p>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleSellClose}>
            No
          </OutlinedButton>

          <ContainedButton
            variant="contained"
            sx={{ mx: 2 }}
            onClick={handleSell}
          >
            Yes
          </ContainedButton>
        </Box>
      </ModalContent>

      <InfoPopUp
        open={infoModal}
        onClose={handleCloseInfoModal}
        title={Infomodal[infoIndex]?.title}
        description={Infomodal[infoIndex]?.description}
      />
    </Box>
  );
};

// ── Design System Styles ──────────────────────────────────────────────────────
const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};
const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};
const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};
const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};
const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};
const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};
const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};
const sectionCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
  mb: 2,
};
const cardSectionTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  letterSpacing: "-0.01em",
};
const sectionHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 2,
  py: 1.5,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};
const modernTableHeadRow = { backgroundColor: "var(--body-color-less2)" };
const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
  backgroundColor: "var(--body-color-less2)",
};
const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};
const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};
// ─────────────────────────────────────────────────────────────────────────────

export default MyWalletOption;
